import React from 'react';
import {
    Datagrid,
    TextField,
    SearchInput,
    ReferenceField
} from 'react-admin';

import List from '../common/views/List';
import HumanDateField from '../common/fields/HumanDateField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import StatusField from './fields/StatusField';
import CategoryField from './fields/CategoryField';
import ProgressField from './fields/ProgressField';
import PriorityField from './fields/PriorityField';
import ParticipantsListField from './fields/ParticipantsListField';
import StatusInput from './inputs/StatusInput';
import CategoryInput from './inputs/CategoryInput';
import PriorityInput from './inputs/PriorityInput';

const taskFilters = [
    <SearchInput source="q" alwaysOn />,
    <StatusInput source="status" alwaysOn />,
    <CategoryInput source="category" alwaysOn />,
    <PriorityInput source="priority" alwaysOn />,
];

const TaskList = props => (
    <List filters={taskFilters} {...props} exporter={false}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="title" />
            <CategoryField source="category" />
            <StatusField source="status" />
            <PriorityField source="priority" />
            <ProgressField source="progress" />
            <ReferenceField label="Owner" source="owner_id" reference="users">
                <TextField source="fullname" />
            </ReferenceField>
            <ParticipantsListField label="Participants" />
            <HumanDateField source="due_date" />
            <HumanDateField source="updated_at" />
            <RecordSplitButton />
        </Datagrid>
    </List>
);

export default TaskList;
